module.exports = __webpack_public_path__ + "static/media/flightHours.5b5e3c08.png";